<template>
    <nav>
      <ol class="breadcrumb">
        <li v-for="(crumb, index) in crumbs" :key="index" class="breadcrumb-item align-itrm-center">
          <router-link :to="crumb.route" :class="{disabled: isLast(index)}">{{ crumb.text }}</router-link>
           <!-- <button class="btn btn-link" :class="{disabled: isLast(index)}" @click="selected(crumb)">
             {{ crumb }}
           </button> -->
        </li>
      </ol>
    </nav>
</template>
  
<script>
  export default {
    props: {
      blogId: Number
    },
    methods: {
      isLast (index) {
        console.log('index', index)
        console.log('isLast', index === this.crumbs.length - 1)
        return index === this.crumbs.length - 1
      },
      selected (crumb) {
        this.$emit('selected', crumb)
      }
    },
    computed: {
      crumbs () {
        return [
          { text: 'Beneat Blog', route: '/blog' },
          { text: 'รายละเอียดบทความ', route: `/blog/${this.blogId}` }
          // Add more breadcrumbs as needed
        ]
      }
    }
  }
</script>
<style scoped lang="scss">
.breadcrumb {
    background-color: white !important;
    // color: #313131 !important;
    padding: 0 !important;
    a {
      color: #7F7F7F ;
    }
}
.disabled {
  color: #313131 !important;
  cursor: not-allowed;
  pointer-events: none;
  // opacity: 0.7;
}
.breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: 0.5rem;
    color: #6c757d;
    content: ">" !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/blogs/components/Breadcrumb.vue